<script setup lang="ts">
import type { ISegmentControlsOption } from '@/features/ui-kit';

import { EFeatureValue, EFeatureName } from '~/features/feature-flags';
import { useDevToolbar } from '../../business/form';
import { SegmentControl } from '@/features/ui-kit';

const { formData } = useDevToolbar();

const options: Array<ISegmentControlsOption> = [
  { label: 'On', value: EFeatureValue.ENABLED },
  { label: 'Off', value: EFeatureValue.DISABLED },
  { label: 'Unset', value: EFeatureValue.UNSET },
];
</script>

<template>
  <div class="ff-tab">
    <SegmentControl
      label="Кэширование REST-запросов"
      :options="options"
      v-model="formData[EFeatureName.CACHE_API_SERVICE].value"
    />

    <SegmentControl
      label="Безакцептная оплата"
      :options="options"
      v-model="formData[EFeatureName.CHECKOUT_NON_ACCEPTANCE_PAYMENT].value"
    />

    <SegmentControl
      label="Комбо-товары"
      :options="options"
      v-model="formData[EFeatureName.COMBO].value"
    />

    <SegmentControl
      label="Только кнопка 'добавить в корзину'"
      :options="options"
      v-model="formData[EFeatureName.ADD_BUTTON_ONLY].value"
    />

    <SegmentControl
      label="Логирование ошибок в Sentry"
      :options="options"
      v-model="formData[EFeatureName.SENTRY].value"
    />

    <SegmentControl
      label="Переключение языка"
      :options="options"
      v-model="formData[EFeatureName.LOCALE].value"
    />

    <SegmentControl
      label="Долями в карточке товара"
      :options="options"
      v-model="formData[EFeatureName.PRODUCT_PAYMENT_DOLYAME].value"
    />

    <SegmentControl
      label="Баннеры 11.11 на странице товара и в корзине"
      :options="options"
      v-model="formData[EFeatureName.PRODUCT_BANNER].value"
    />

    <SegmentControl
      label="Сбер промо (промо в корзине)"
      :options="options"
      v-model="formData[EFeatureName.SBER_PROMO].value"
    />

    <SegmentControl
      label="Новая сортировка отзывов"
      :options="options"
      v-model="formData[EFeatureName.NEW_RATES].value"
    />

    <SegmentControl
      label="Популярные категории"
      :options="options"
      v-model="formData[EFeatureName.PROMO_IMAGE_BLOCK].value"
    />

    <SegmentControl
      label="Промо-попапы"
      :options="options"
      v-model="formData[EFeatureName.NOTIFICATION_POPUP].value"
    />
  </div>
</template>

<style scoped lang="stylus">
.ff-tab
  display flex
  flex-direction column
  gap 16px
</style>
